
































import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import Alert from '@/components/atoms/Alert.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import ListItem from '@/components/molecules/ListItem.vue'

export default Vue.extend({
  name: 'SignIn',
  components: {
    SimpleLoader,
    PageTitle,
    ButtonWrap,
    RoundButton,
    ListItem,
    Alert
  },
  data() {
    return {
      mail: '',
      password: ''
    }
  },
  computed: {
    isAuthLoading(): boolean {
      return this.$state.auth.isAuthLoading
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll('signinForm').then(async result => {
        if (result) {
          await this.$store.dispatch('auth/login', {
            email: this.mail,
            password: this.password
          })
        }
      })
    }
  }
})
